import { useEffect, useRef } from 'react';

// Its selecting the input you pass in as a ref on mounting
// either use the ref directly with `inputRef` or use a function that will set
// the ref

// You can pass an additional flag to the hook that will listen on changes and
// focus again when this will change

const useFocusFirstInput = (flag?: boolean) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const setInputRef = (ref: HTMLInputElement | null) => {
    inputRef.current = ref;
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [flag]);
  return { setInputRef, inputRef };
};

export default useFocusFirstInput;
